import React, { ReactNode } from "react"
import Components from "../index"
import { blokType, sbAssetType } from "../../types"
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import remarkReactComponents from "../../helpers/remarkReactComponents"
import { StaticQuery, graphql } from "gatsby"
import {
  StyledProgramProps,
  StyledProgramCard,
  StyledContent,
  StyledProgramHeader,
  StyledProgramHeading,
  StyledInfo,
  StyledProgramTitle,
  StyledProgramDescription,
  StyledAttributes,
  StyledAttribute,
  StyledButtonContainer,
  StyledCardButtons,
  StyledIcon,
} from "./partials"
import IconV2 from "../icon-v2"

export interface ProgramCardProps extends StyledProgramProps {
  title: string
  description: string
  degree: string
  header_image: sbAssetType
  location: Array<any>
  specialization: Array<string>
  initial_hide: boolean
  duration: string
  timeline: string
  cta_web: blokType[]
  cta_lp1: blokType[]
  cta_lp2: blokType[]
  cta_lp3: blokType[]
}

export const ProgramCardCmp: React.FC<ProgramCardProps> = ({
  title,
  description,
  degree,
  header_image,
  location,
  specialization,
  initial_hide = false,
  duration,
  timeline,
  cta_web,
  cta_lp1,
  cta_lp2,
  cta_lp3,
}) => (
  <StaticQuery
    query={graphql`
      query {
        allStoryblokDatasourceEntry(
          filter: { data_source: { regex: "/^program-/" } }
        ) {
          edges {
            node {
              data_source
              name
              value
              dimension_value
              data_source_dimension
            }
          }
        }
      }
    `}
    render={(data) => {
      const sBdataSource = data.allStoryblokDatasourceEntry.edges

      return (
        <>
          <StyledProgramCard data-name="card-program">
            {degree && (
              <StyledProgramHeader
                degree={degree}
                header_image={header_image ? header_image.filename : ""}
              >
                <StyledProgramHeading>{degree}</StyledProgramHeading>
              </StyledProgramHeader>
            )}
            <StyledContent>
              <div>
                <StyledInfo>
                  {title && title !== "" && (
                    <StyledProgramTitle>{title}</StyledProgramTitle>
                  )}
                  {description && description !== "" && (
                    <StyledProgramDescription>
                      {
                        unified()
                          .use(remarkParse)
                          .use(remarkRehype)
                          .use(rehypeReact as any, {
                            createElement: React.createElement,
                            components: remarkReactComponents,
                            Fragment: React.Fragment
                          })
                          .processSync(description).result as ReactNode
                      }
                    </StyledProgramDescription>
                  )}
                </StyledInfo>
              </div>
              <div>
                <StyledAttributes>
                  {location && (
                    <StyledAttribute>
                      <StyledIcon degree={degree}>
                        <IconV2 icon={"school"} />
                      </StyledIcon>
                      <p>{location.map((x) => x).join(", ")}</p>
                    </StyledAttribute>
                  )}
                  {duration && (
                    <StyledAttribute>
                      <StyledIcon degree={degree}>
                        <IconV2 icon={"check"} />
                      </StyledIcon>
                      <p>{duration}</p>
                    </StyledAttribute>
                  )}
                  {timeline && (
                    <StyledAttribute>
                      <StyledIcon degree={degree}>
                        <IconV2 icon={"calendar"} />
                      </StyledIcon>
                      <p>{timeline}</p>
                    </StyledAttribute>
                  )}
                </StyledAttributes>
                <StyledButtonContainer>
                  {cta_web && cta_web.length > 0 && (
                    <StyledCardButtons single_button={cta_web.length === 1}>
                      {cta_web.map((content: blokType) =>
                        React.createElement(Components(content.component), {
                          key: content._uid,
                          blok: content,
                        })
                      )}
                    </StyledCardButtons>
                  )}
                  {cta_lp1 && cta_lp1.length > 0 && (
                    <StyledCardButtons single_button={cta_lp1.length === 1}>
                      {cta_lp1.map((content: blokType) =>
                        React.createElement(Components(content.component), {
                          key: content._uid,
                          blok: content,
                        })
                      )}
                    </StyledCardButtons>
                  )}
                  {cta_lp2 && cta_lp2.length > 0 && (
                    <StyledCardButtons single_button={cta_lp2.length === 1}>
                      {cta_lp2.map((content: blokType) =>
                        React.createElement(Components(content.component), {
                          key: content._uid,
                          blok: content,
                        })
                      )}
                    </StyledCardButtons>
                  )}
                  {cta_lp3 && cta_lp3.length > 0 && (
                    <StyledCardButtons single_button={cta_lp3.length === 1}>
                      {cta_lp3.map((content: blokType) =>
                        React.createElement(Components(content.component), {
                          key: content._uid,
                          blok: content,
                        })
                      )}
                    </StyledCardButtons>
                  )}
                </StyledButtonContainer>
              </div>
            </StyledContent>
          </StyledProgramCard>
        </>
      )
    }}
  />
)
